import React from 'react';
import { Box, Typography } from '@mui/material';
import { PatientProfileInfoAccordion } from './PatientProfileInfoAccordion';
import { usePatientDiagnosisQuery } from '@uplift/queries';


export type DiagnosisAccordionProps = {
  patientId: string;
};


export const PatientDiagnosisAccordion: React.FC<DiagnosisAccordionProps> = (props) => {
  const { data: diagnosis } = usePatientDiagnosisQuery(props.patientId);

  if (!diagnosis?.length) {
    return null;
  }

  return (
    <PatientProfileInfoAccordion title="Diagnosis" expandable={false} initialExpanded>
      <Box display="flex" flexDirection="column" gap="8px" width="100%">
        {diagnosis?.map(d => (
          <Box key={d.id} fontWeight={500}>
            <Typography>{d.name} ({d.code})</Typography>
          </Box>
        ))}
      </Box>
    </PatientProfileInfoAccordion>
  );
};
